import * as isMobileJS from "ismobilejs";
import { FacebookAppShareAdapter } from "./FacebookAppShareAdapter";
import { FacebookBasicShareAdapter } from "./FacebookBasicShareAdapters";
import { TwitterShareAdapter } from "./TwitterShareAdapter";
import { WhatsappShareAdapter } from "./WhastappShareAdapter";
import { DataUtils } from "../../utils/DataUtils";
export class ShareManager {
    constructor(data) {
        this._adapters = {};
        this._data = data;
        data.sharing.adapters.forEach((adapterData) => {
            this.createAdapter(adapterData);
        });
    }
    createAdapter(adapterData) {
        const type = adapterData.adapter.split('.')[0];
        if (this._adapters[type]) {
            logger.error('using multiple ' + type + ' sharing adapters');
        }
        let adapter = null;
        switch (adapterData.adapter) {
            case "facebook.app":
                adapter = new FacebookAppShareAdapter();
                break;
            case "facebook.basic":
                adapter = new FacebookBasicShareAdapter();
                break;
            case "twitter.basic":
                adapter = new TwitterShareAdapter();
                break;
            case "whatsapp.basic":
                if (isMobileJS.phone) {
                    adapter = new WhatsappShareAdapter();
                }
                break;
            default:
                logger.error(adapterData.adapter + ' adapter not found');
        }
        if (adapter) {
            const image = this._data.sharing.image ? DataUtils.imageLookup(this._data.sharing.image, 'large') : null;
            const shareData = {
                url: '',
                title: '',
                desc: '',
                adapterData: adapterData,
                image: image ? image.url : ''
            };
            shareData.url = window.top.document.location.href;
            this._adapters[type] = adapter;
            adapter.init(shareData, this._data.scriptManager);
        }
    }
    getAdapter(adapterName, optional = false) {
        const adapter = this._adapters[adapterName];
        if (adapter) {
            return this._adapters[adapterName];
        }
        else {
            if (!optional) {
                logger.error('adapter ' + adapterName + ' wasnt created');
            }
            return null;
        }
    }
}
